import { createRouter, createWebHistory } from 'vue-router'
import index from "@/components/views/index";
//import convertisseur from "@/components/views/convertisseur";
//import marketcup from "@/components/views/marketcup";
import notification from "@/components/views/notification";


/*

import tbdefinitionpersonnel from "@/components/views/pages/definition/personnel/index";
import tbdefinitionoccasionnel from "@/components/views/pages/definition/occasionnel/index";
import indedefinitionfichierbase from "@/components/views/pages/definition/tiers/fichiersdebase/index";
import tbpaie from "@/components/views/pages/paie/tb";
import tbpresence from "@/components/views/pages/presence/tb";
import trapport from "@/components/views/pages/rapport/tb";
import indexpaiepermanentencour from "@/components/views/pages/paie/permanent/tb";
import bulletindepaie from "@/components/views/pages/paie/permanent/bulletindepaie/bulletindepaie";
import bulletindepaieoccasionnel from "@/components/views/pages/paie/occasionnel/bulletindepaie/bulletindepaie";
import avancesursalairepaieoccasionnel from "@/components/views/pages/paie/occasionnel/avance_sur_salaire/index";
import honoraireaotachepaieoccasionnel from "@/components/views/pages/paie/occasionnel/honoraireao/index";
import traitementdebasedelapaiedespermanents from "@/components/views/pages/paie/permanent/retenue/index";
import heuresupplementairepaiedespermanents from "@/components/views/pages/paie/permanent/heuresupplementaire/index";
import indexpaieencouroccasionnel from "@/components/views/pages/paie/occasionnel/tb";

*/




//************************* HSIGCOM *****************************//
import tbdefinition from "@/components/views/pages/definition/tb";
import trapport from "@/components/views/pages/rapport/tb";
import tstock from "@/components/views/pages/stock/tb";
 import tcaisse from "@/components/views/pages/caisse/tb";
 import caisse_en_cour from "@/components/views/pages/caisse/indexcaisse";
 import tgestioncommerciale from "@/components/views/pages/gestioncommerciale/tb";
 import tsetting from "@/components/views/pages/setting/tb";
 import tableaudebord from "@/components/views/pages/tableaudebord/tb";
 import tmodifiermotdepasse from "@/components/views/pages/modifiermotdepasse";
 import tutilitaires from "@/components/views/pages/utilitaires/tb";
 import tscanandgo from "@/components/views/pages/scanandgo/index";
 import tcuisine from "@/components/views/pages/cuisine/index";
 import tbar from "@/components/views/pages/bar/index";
 import panierapp from "@/components/views/pages/panier/index";
 import panierrefus from "@/components/views/pages/panier/refus";
 import menuapp from "@/components/views/pages/menu/index";
 import serveurapp from "@/components/views/pages/serveur/index";
 import shortlinkapp from "@/components/views/pages/shortlink/index";
 import scancaisseapp from "@/components/views/pages/scancaisse/index";
 import tprevisionperformance from "@/components/views/pages/previsionperformance/index";
 //import tableaudebord from "@/components/views/pages/tableaudebord/ok_old_tb";


import tcomptable from "@/components/views/pages/comptabilite/tb";
import tmenucomptable from "@/components/views/pages/comptabilite/indexcomptable";




import loginpage from "@/components/views/auth/login";
import registerpage from "@/components/views/auth/register";

/************************* RESTAURANT ****************/

import RestaurantSelector from '@/components/views/pages/restaurant/restaurantselector.vue';
import ServeurTables from '@/components/views/pages/restaurant/serveurtables.vue';
import ServeurPriseCommande from '@/components/views/pages/restaurant/serveurprisecommande.vue';
import BarDashboard from '@/components/views/pages/restaurant/bardashboard.vue';
import CuisineDashboard from '@/components/views/pages/restaurant/cuisinedashboard.vue';
import CaisseDashboard from '@/components/views/pages/restaurant/caissedashboard.vue';
import AdminRestaurants from '@/components/views/pages/restaurant/adminrestaurants.vue';
import CommandeDetails from '@/components/views/pages/restaurant/commandedetails.vue'; // ← AJOUT

import dashboardgestioncommandesligne from '@/components/views/pages/restaurant/online/dashboardgestioncommandesligne'; // ← AJOUT
import onlineorderform from '@/components/views/pages/restaurant/online/onlineorderform'; // ← AJOUT

const routes = [
    //******************************* HCLINIQUE **************************************--//

    {
        name:'tsetting',
        path: '/setting',
        component: tsetting,
        meta: {
            requiresAuth: true,
            roles: ['Administrateur']
        }
    },

    {
        name:'trapport',
        path: '/rapport',
        component: trapport,
        meta: {
            requiresAuth: true,
            roles: ['Membre','Administrateur']
        }
    },

    {
        name:'tcomptable',
        path: '/comptabilite',
        component: tcomptable,
        meta: {
            requiresAuth: true,
            roles: ['Membre','Administrateur']
        }
    },

    {
        name:'tmenucomptable',
        path: '/exercice/:periode',
        component: tmenucomptable,
        meta: {
            requiresAuth: true,
            roles: ['Membre','Administrateur']
        }
    },

    {
        name:'tableaudebord',
        path: '/tableaudebord',
        component: tableaudebord,
        meta: {
            requiresAuth: true,
            roles: ['Membre','Administrateur']
        }
    },




    {
        name:'tmodifiermotdepasse',
        path: '/motdepasse',
        component: tmodifiermotdepasse,
        meta: {
            requiresAuth: true,
            roles: ['Membre','Administrateur']
        }
    },


    {
        name:'tbdefinition',
        path: '/definition',
        component: tbdefinition,
        meta: {
            requiresAuth: true,
            roles: ['Membre','Administrateur']
        }
    },

    {
        name:'tstock',
        path: '/stock',
        component: tstock,
        meta: {
            requiresAuth: true,
            roles: ['Membre','Administrateur']
        }
    },
    {
        name:'tgestioncommerciale',
        path: '/gestion_commerciale',
        component: tgestioncommerciale,
        meta: {
            requiresAuth: true,
            roles: ['Membre','Administrateur']
        }
    },

    {
        name:'tcaisse',
        path: '/caisse',
        component: tcaisse,
        meta: {
            requiresAuth: true,
            roles: ['Membre','Administrateur']
        }
    },

    {
        name:'tprevisionperformance',
        path: '/prevision_performance',
        component: tprevisionperformance,
        meta: {
            requiresAuth: true,
            roles: ['Membre','Administrateur']
        }
    },

    {
        name: 'caisseencour',
        path: '/caisse/caisse_en_cour',
        component: caisse_en_cour,
        meta: {
            requiresAuth: true,
            roles: ['Administrateur']
        }
    },

    {
        name:'login',
        path: '/login',
        component: loginpage,
        meta: {
            requiresAuth: false,
            roles: ['Membre','Administrateur']
        }
    },
    {
        name:'register',
        path: '/register',
        component: registerpage,
        meta: {
            requiresAuth: false,
            roles: ['Membre','Administrateur']
        }
    },

    {
        name:'acceuilpage',
        path: '/',
        component: index,
        meta: {
            requiresAuth: true,
            roles: ['Membre','Administrateur']
        }
    },
 
 
    //***************************************************************//
 
   {
       name:'notification',
    path: '/notification',
    component: notification,
       meta: {
           requiresAuth: true,
           roles: ['Membre','Administrateur']
       }
  },


    // Autres routes définies ici...

    {
        name: 'tutilitaires',
        path: '/utilitaires',
        component: tutilitaires,
        meta: {
            requiresAuth: true,
            roles: ['Membre','Administrateur']
        }
    },

    {
        name: 'tscanandgo',
        path: '/scan-and-go',
        component: tscanandgo,
        meta: {
            requiresAuth: true,
            roles: ['Administrateur']
        }
    },

    /* Écran de production CUISINE. Poste interne authentifié (contrairement à
       /serveur et /panier qui sont publics) : il s'ouvre depuis le menu, puis se
       rattache à la room de la caisse par un code délivré par celle-ci. */
    {
        name: 'tcuisine',
        path: '/cuisine',
        component: tcuisine,
        meta: {
            requiresAuth: true,
            roles: ['Administrateur']
        }
    },

    /* Écran de production BAR. Jumeau de /cuisine : même socle, autre poste.
       Deux routes distinctes plutôt qu'un paramètre, pour que chaque poste ait
       sa propre entrée de menu et sa propre permission. */
    {
        name: 'tbar',
        path: '/bar',
        component: tbar,
        meta: {
            requiresAuth: true,
            roles: ['Administrateur']
        }
    },

    {
        name: 'panierapp',
        //path: '/panier/:soc/:mag/:key/:rand1?',
        path: '/panier/:mag/:key',
        component: panierapp,
        meta: {
            requiresAuth: false,
            roles: ['Membre','Administrateur']
        }
    },

    {
        // Refus d'accès au Scan & Go. Le code d'erreur passe en query ; la clé
        // de licence, elle, ne transite jamais par une URL (cf. refus.vue).
        // meta.roles est obligatoire : le guard de main.js fait un
        // to.meta.roles.includes(...) sans garde et planterait sinon.
        name: 'panierrefus',
        path: '/panier-refus',
        component: panierrefus,
        // 't' choisit la formulation : 'menu' pour le parcours restaurant,
        // absent pour le Scan & Go. Aucune donnée sensible n'y transite.
        props: route => ({ c: route.query.c || '', t: route.query.t || '' }),
        meta: {
            requiresAuth: false,
            roles: ['Membre','Administrateur']
        }
    },

    {
        name: 'menuapp',
       // path: '/menu/:soc/:mag/:key/:table?/:r1?',
        path: '/menu/:mag/:key/:table?',
        component: menuapp,
        meta: {
            requiresAuth: false,
            roles: ['Membre','Administrateur']
        }
    },

    /* Application serveur : prise de commande en salle sur le téléphone du
       personnel. Le serveur ouvre l'app en scannant l'affiche murale du
       restaurant (le QR à table="0" de la page Scan & Go), s'identifie une
       fois, puis produit un QR par commande que le caissier scanne.

       Paramètres obligatoires : le module vérifie l'accès par /verifyaccess
       comme menuapp, une URL incomplète est refusée (PARAMS_INVALID). */
    {  
        name: 'serveurapp',
       // path: '/serveur/:soc/:mag/:key/:r1?',
        path: '/serveur/:mag/:key?',
        component: serveurapp,
        meta: {
            requiresAuth: false,
            roles: ['Membre','Administrateur']
        }
    },

    /* Téléphone-scanner de la caisse. Route publique : le téléphone n'a ni compte
       ni session, l'autorité est le couple room/token de l'appairage, délivré à une
       caisse authentifiée et vérifié à la connexion socket. */
    {
        name: 'scancaisseapp',
        path: '/scancaisse/:room/:token',
        component: scancaisseapp,
        meta: {
            requiresAuth: false,
            roles: ['Membre','Administrateur']
        }
    },

    /* Page interstitielle du raccourcisseur de QR. Route PUBLIQUE : le QR (affiche
       panier/menu, enrôlement serveur) ne porte qu'un code court ; cette page le
       résout auprès du backend puis redirige vers la cible réelle, ou affiche
       « Authentification non correcte ». Chemin court volontaire (densité du QR). */
    {
        name: 'shortlinkapp',
        path: '/s/:code',
        component: shortlinkapp,
        meta: {
            requiresAuth: false,
        }
    },

    {
        path: '/#',
        redirect: '/login',
    },

    {
        path: '/:pathMatch(.*)*', // Route par défaut pour toutes les URL non définies
        redirect: '/login',
    },
/*************************** RESTAURANT ****************************/


    { path: '/restaurantselector', name: 'RestaurantSelector', component: RestaurantSelector },
    { path: '/serveur/tables', name: 'ServeurTables', component: ServeurTables },
    { path: '/serveur/commande/:tableId', name: 'ServeurPriseCommande', component: ServeurPriseCommande, props: true },
    { path: '/bardashboard', name: 'BarDashboard', component: BarDashboard },
    { path: '/cuisinedashboard', name: 'CuisineDashboard', component: CuisineDashboard },
    { path: '/caissedashboard', name: 'CaisseDashboard', component: CaisseDashboard },
    { path: '/adminrestaurants', name: 'AdminRestaurants', component: AdminRestaurants },
    { path: '/commande/:orderId', name: 'CommandeDetails', component: CommandeDetails, props: true },


    { path: '/gestion-commandes-en-ligne', name: 'OnlineOrdersDashboard', component: dashboardgestioncommandesligne },
    { path: '/commande-en-ligne', name: 'OnlineOrderForm', component: onlineorderform },
]

const router = createRouter({
 // history: createWebHistory(process.env.BASE_URL),
   history: createWebHistory(),
  routes
})

export default router




